module.exports = __webpack_public_path__ + "media/assets/information2-ef447a2d7b1771932a5963497474badb362717d832d3cb178ef233336225cf31.svg";